import { useAmplitude } from 'hooks/useAmplitude';
import { useGlobals } from 'hooks/useGlobals';
import { useSendTracking } from 'hooks/useSendTracking';
import React from 'react';

const useTruckInformationEvents = () => {
  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();
  const { user } = useGlobals();

  const truckerProfileOpenned = (
    type: string,
    truckerId: string,
    vehicleId: string,
    appeared: number,
    photosShowed: number,
    event?: React.MouseEvent
  ) => {
    const companyId = user?.data?.company?.id;

    sendAmplitude('trucker_profile_openned', {
      type,
      truckerId,
      vehicleId,
      appeared,
      photosShowed,
      companyId,
    });
    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_openned',
        clickEvent: event,
        data: {
          type,
          truckerId: `hashed|${truckerId}`,
          vehicleId: `hashed|${vehicleId}`,
          companyId: `hashed|${companyId}`,
          appeared,
          photosShowed,
        },
      },
      'events'
    );
  };

  return { truckerProfileOpenned };
};

export default useTruckInformationEvents;
